/// <summary>
/// This object provides js functions for the Bluaul.VC.Widget.DataCenter.ZstDifList.cs <br/>
/// <br/>
/// Author: ARF<br />
/// Date: 27.8.2021<br />
/// Copyright ©: EUDT GmbH 2021 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 27.8.2021                                               *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
jQuery.widget("bluaul.DsZstDifList", jQuery.common.VisualBase, {
    vcV: new vcVisual(),
    date: null,
    _create: function () {
        var me = this;
        try {
           
            me.element.html("");
            // set the Visual-Name first
            me.options.invoke.vcvid = 338;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));

            //inits the super class
           
            me._super();
         
        } catch (e) {
            me.writeError('_create', e);
            return false;
        }
        return true;
    },

    _initHTML: function () {
        var me = this;
        try {
          
            me.showMessage("", false);
           
            ////adopt heights and widths
            var h = parseInt(me.visual.height() -
                me.fnd(".vc-list-header").height() -
                me.fnd("#div-filter-menu").height());
            me.fnd(".lst-entries").height(parseInt(h));

          
        } catch (e) {
            me.writeError('_initHTML', e);
            return false;
        }
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {
            //console.info(me.settings);
            //alert(me.settings.userLangIDForCulture);
            me.fnd("#div-date").vcDateBox({
                mode: "Range", align: "center", interval: 1, langID: me.settings.userLangIDForCulture, callback: function (obj) { me.date = obj.dateRange;}
            });

            //generate the option boxes
            var htmlLogger = me.element.find(".log").clone();
            me.fnd(".log").replaceWith(
                $("<div>", { "class": "log-box box1 vc-grid-2col vc-grid-margin-right vc-grid-margin-bottom" })
            );
            me.fnd(".log-box").vcOptionBox({
                caption: me.resources.selection,
                items: [{ button: me.specific.resources.logger, clickable: false, isList: true, content: htmlLogger.clone() }]
            });

            me.fnd("#div-tolerance").vcOptionBox({
                caption: me.resources.selection,
                items: [{ button: me.specific.resources.tolerance + " (%)", clickable: false, isList: false, content: $("<input>").addClass("txtEnabled").attr("id", "txt-tolerance").attr("type", "number") }]
            });
            me.fnd("#txt-tolerance").val(me.specific.tolerance);

            me._fetch();

            me.element.on("click", "#div-btn-reload", function (e) {
                me._fetch();
            });

        
            me.fnd(".lst-entries").off("click", ".ds-edit-popup").on("click", ".ds-edit-popup",
                function (e) {
                    me.vcV.showDsEdit2Dialog({ LoggerId: parseInt($(e.target).data("blid")), bsaid: parseInt($(e.target).data("bsaid")), day: $(e.target).data("date") });
                
                    e.stopPropagation()
                });


        } catch (e) {
            me.writeError('_initEvents', e);
            return false;
        }
        return true;
    },



    _fetch: function () {
        /// <summary>
        /// This function fetches existing entries incl. filter options
        /// </summary>
        var me = this;
        var param;
        try {

            param = {};
            param.ID = -1;
            param.loggerid = parseInt(me.fnd("#div-filter-menu .log").val());
            param.From = me.date.from;
            param.To = me.date.to;

            var tolerance = me.fnd("#txt-tolerance").val();
            tolerance = tolerance.replace(".", ",");
           
            if (!validateNumeric(tolerance)) {
                me.openInfoDialog(me.specific.resources.ERR_inputInvalid_lbl, { at: 'center center-20%', of: window });

                return false;
            }

            param.Tolerance = parseFloat(me.fnd("#txt-tolerance").val());
            me.fnd(".lst-entries").html(me.getLoadingIcon());
          
            me.getData(param, function (result) {
                //check response content
               if (result == null) {
                   me.showMessage(me.resources.err_loadData, true);
                   return true;
               }
            
                me._generateList(result);
              
                return true;
            });

        } catch (e) { me.writeError('_fetch', e); return false;}
        return true;
    },

    _generateList: function (dtt) {
        /// <summary>
        /// This function generates a list from the data and ...
        /// nothing too complicated
        /// </summary>
        var me = this;
        var item;
        var list;
        try {

            list = me.fnd(".lst-entries");
            list.html("");

            if (dtt === null) {
                list.html($("<br>"));
                list.append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return false;
            }
             
            if (dtt.rows === null) {
                list.html($("<br>"));
                list.append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return false;
            }
           

            for (var i = 0; i < dtt.rows.length; i++) {

                item = $("<div>", { "class": "vc-list-item" });
                //item.data("id", dtt.rows[i].bsaid);
                //item.data("day", dtt.rows[i].day);
              

                item.append($("<div>", { "class": "vc-list-col col0" }).html($("<div>", { "class": "vc-list-col-element", "html": dtt.rows[i].project })));
                item.append($("<div>", { "class": "vc-list-col col1" }).html($("<div>", {
                    "class": "vc-list-col-element", "html": dtt.rows[i].name + " [" + dtt.rows[i].dims + "] <i data-bsaid='" + dtt.rows[i].bsaid + "' data-blid='" + dtt.rows[i].blid + "' data-date='" + $.datepicker.formatDate('dd.mm.yy', dtt.rows[i].day) + "' class='ds-edit-popup vc-list-icon popup fa fa-laptop-medical color-font-secondary'></i>" })));
                item.append($("<div>", { "class": "vc-list-col col11" }).html($("<div>", { "class": "vc-list-col-element", "html": dtt.rows[i].hw_name })));
                item.append($("<div>", { "class": "vc-list-col col2" }).html($("<div>", { "class": "vc-list-col-element", "html": $.datepicker.formatDate('dd.mm.yy', dtt.rows[i].day) })));
                item.append($("<div>", { "class": "vc-list-col col3" }).html($("<div>", { "class": "vc-list-col-element value", "html": dtt.rows[i].zst_prev })));
                item.append($("<div>", { "class": "vc-list-col col4" }).html($("<div>", { "class": "vc-list-col-element value", "html": dtt.rows[i].zst })));

                item.append($("<div>", { "class": "vc-list-col col5" }).html($("<div>", { "class": "vc-list-col-element value", "html": dtt.rows[i].zstdiff })));

               
                var archiveStatus = "";
                if (dtt.rows[i].status.indexOf("1") > -1) { archiveStatus = "<i class='fa fa-edit color-font-secondary'></i>"; }
                if (dtt.rows[i].status.indexOf("2") > -1) { archiveStatus += "<i class='fa-regular fa-times-circle icon-color-error'></i>"; }
                if (archiveStatus == "") archiveStatus = "<br/>";
                status = "<span title='" + dtt.rows[i].status + "'>" + archiveStatus + "</span>";
               


                item.append($("<div>", { "class": "vc-list-col col6" }).html($("<div>", { "class": "vc-list-col-element value", "html": dtt.rows[i].sum  })));
                item.append($("<div>", { "class": "vc-list-col col61" }).html($("<div>", { "class": "vc-list-col-element ", "html": status })));
                item.append($("<div>", { "class": "vc-list-col col7" }).html($("<div>", { "class": "vc-list-col-element value", "html": dtt.rows[i].errordiff })));
                item.append($("<div>", { "class": "vc-list-col col8" }).html($("<div>", { "class": "vc-list-col-element value", "html": dtt.rows[i].errordiffpercent })));
                item.append($("<div>", { "class": "vc-list-col col9" }).html($("<div>", { "class": "vc-list-col-element value", "html": dtt.rows[i].tolerance })));
              
            
                list.append(item);
            }

            me.fnd('.lst-entries .vc-list-item:even').addClass('alt');

            me.fnd('.lst-entries .vc-list-item .vc-list-col-element.value').formatDouble(2);

            return true;
        } catch (e) {
            me.writeError('_save', e); return false;
        }

    },


    //_showChart: function (obj) {
    //    /// <summary>
    //    /// This function shows an chart
    //    /// </summary>
    //    var me = this;
    //    try {
           
    //        var myParam = JSON.parse(JSON.stringify(obj.data("settings")));
    //        me.container = me.getRandomIDContainerObj("div-chart-preview-", false);
         
    //        me.container.obj.height(490);
    //        me.container.obj.width(960);
    //        $("#div-chart-preview").html(me.container.obj);
            
    //        new window.vcVisual().addVisualBase('div-chart-preview-', myParam.VCVID, me.container.random, window.getCurrentTimestamp(), 490, 950, myParam.Parameter, myParam.SignalParameter, myParam.DeviceType);


    //    } catch (e) { me.writeError('_showChart', e); return false; }
    //    return true;
    //},
    
    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
                me.fnd(".lst-entries, #div-filter-menu").hide();
            }
            return true;
        } catch (e) {
            me.writeError('specificInfoHandling', e); return false;
        }
    }


});

